import { useMemo } from 'react';
import { useTreeReferencesContext } from '../../../../../../../tree/references/TreeReferencesContext.tsx';
import { ExpressionReferenceInput } from '../../../../../../expressions/references/input/ExpressionReferenceInput.tsx';
import { WidgetType } from '../../../../../Widget.ts';
import { ButtonActionContainer } from '../style/ButtonActionContainer.tsx';

export interface IButtonActionListAddConfigProps {
  name: string;
}

export function ButtonActionListAddConfig(
  props: IButtonActionListAddConfigProps,
) {
  const { references, root } = useTreeReferencesContext();

  const componentName = useMemo(() => {
    return `${props.name}.listReference`;
  }, [props.name]);

  if (!root) return null;

  return (
    <ButtonActionContainer name="Aggiungi alla lista">
      <ExpressionReferenceInput
        width="100%"
        references={references}
        name={componentName}
        config={{
          filter: ref => ref.widgetType === WidgetType.Repeatable,
        }}
      />
    </ButtonActionContainer>
  );
}
